import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ServiceHistoryButton } from "@/components/ServiceHistoryButton";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Loader2, AlertTriangle } from "lucide-react";

export function EnergySwitch({ next }) {
  const { user } = useAuth();
  const [provider, setProvider] = useState(null);
  const { user: viewer } = useAuth();
  const load = useCallback(() => {
    setProvider(null);
    api.get("/energy/provider").then((r) => setProvider(r.data)).catch(() => setProvider({ provider: "error" }));
  }, []);
  useEffect(load, [load]);
  if (!provider) return <Loader2 className="w-6 h-6 animate-spin" data-testid="energy-switch-loading" />;
  if (provider.provider === "greenpower") return <div className="space-y-4">
    {["dealer", "agent", "admin"].includes(viewer?.role) && provider.commission_payouts_enabled !== true && <p className="inline-flex items-center gap-1.5 rounded-full border border-amber-500/30 bg-amber-500/5 px-3 py-1 text-xs text-amber-600 dark:text-amber-400" role="status" title="Puoi creare proposte e contratti. Gli accrediti automatici delle provvigioni Venergia sono sospesi fino a conferma dell'amministrazione." data-testid="energy-payouts-paused">Accrediti provvigioni in attesa di conferma admin</p>}
    {next}
  </div>;
  return (
    <Card className="p-6 max-w-2xl space-y-4 glow-border" data-testid="energy-unavailable">
      <ServiceHistoryButton service="energia" />
      <AlertTriangle className="w-7 h-7 text-amber-500" />
      <h1 className="font-head text-2xl font-bold" data-testid="energy-unavailable-title">{provider.provider === "error" ? "Impossibile verificare Venergia" : "Venergia da configurare"}</h1>
      <p className="text-sm text-muted-foreground" data-testid="energy-unavailable-message">{provider.provider === "error" ? "La verifica del servizio non è riuscita. Riprova tra poco." : "Le nuove pratiche sono sospese finché Venergia non viene configurato e attivato dall'amministrazione."} Il vecchio modulo energia è disattivato e non può essere usato per nuove richieste.</p>
      <div className="flex flex-wrap gap-2">
        <Button variant="outline" onClick={load} data-testid="energy-provider-retry">Riprova</Button>
        {user?.role === "admin" && <Button asChild><Link to="/app/config-energia" data-testid="energy-config-link">Configura Venergia</Link></Button>}
      </div>
    </Card>
  );
}
